(function () {
   var gliderEl = document.querySelector('.comparison-ctps-lp-glider');
   if (!gliderEl || typeof Glider === 'undefined') {
      return;
   }

   new Glider(gliderEl, {
      slidesToShow: 1,
      slidesToScroll: 1,
      scrollLock: true,
      draggable: true,
      duration: 0.5,
      arrows: {
         prev: '.comparison-ctps-lp .glider-prev',
         next: '.comparison-ctps-lp .glider-next',
      },
      dots: '.comparison-ctps-lp-dots',
   });
})();
